'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */


var mapStateToProps = function mapStateToProps(state) {
  var modules = state.auth.modules;

  return {
    modules: modules
  };
};

var RoleBasedAccess = function RoleBasedAccess(props) {
  var children = props.children,
      required = props.required,
      modules = props.modules,
      instead = props.instead,
      dispatch = props.dispatch,
      rest = _objectWithoutProperties(props, ['children', 'required', 'modules', 'instead', 'dispatch']);

  return required !== "*" && modules.indexOf(required) === -1 ? instead === null ? null : _react2.default.cloneElement(instead, Object.assign({}, rest)) : _react2.default.cloneElement(children, Object.assign({}, rest));
};

RoleBasedAccess.defaultProps = {
  required: '',
  instead: null
};

RoleBasedAccess.propTypes = {
  required: _propTypes2.default.string.isRequired,
  modules: _propTypes2.default.array.isRequired,
  instead: _propTypes2.default.node,
  children: _propTypes2.default.node.isRequired
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(RoleBasedAccess);


//////////////////
// WEBPACK FOOTER
// ./node_modules/slide-new-toolkit/dist/RoleBasedAccess/index.js
// module id = 1054
// module chunks = 0